import type { CSSProperties } from 'react';
import NotFoundIconSvg from '../../assets/icons/not_found.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const NotFoundIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <NotFoundIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default NotFoundIcon;
